import { Module } from 'wrapper6'

export default class Accordion extends Module {
  ready (app) {
    const ACCORDION_WRAPPERS = document.querySelectorAll('.accordion-wrap')
    if (ACCORDION_WRAPPERS.length > 0) {
      for (let i = 0; i < ACCORDION_WRAPPERS.length; i++) {
        new AccordionClass(ACCORDION_WRAPPERS[i])
      }
    }
  }
}

class AccordionClass {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.ITEMS = this.WRAPPER.querySelectorAll('.accordion-item')

    if (this.ITEMS.length > 0) {
      for (let i = 0; i < this.ITEMS.length; i++) {
        const ITEM = this.ITEMS[i]
        const TRIGGER = ITEM.querySelector('.accordion-trigger:not(.accordion-trigger--no-items)')
        const TARGET = ITEM.querySelector('.accordion-target')
        const DATA_TARGET = ITEM.getAttribute('data-target');

        // toggle trigger and target
        (TRIGGER && TARGET) && TRIGGER.addEventListener('click', (e) => {
          if (e.target.tagName === 'A') return
          TRIGGER.classList.toggle('open')
          TARGET.classList.toggle('show')

          // toggle extra target
          if (DATA_TARGET !== null) {
            const TARGET_EL = this.WRAPPER.querySelector(`.${DATA_TARGET}`)
            TARGET_EL && TARGET_EL.classList.toggle('show')
          }
        })
      }
    }
  }
}
